import { plainToInstance } from 'class-transformer'

import { SearchBookListParamType } from '@client/collections/Bookmark/interface'
import { CHECK_BOOKMARK } from '@client/collections/Bookmark/schemas/checkBookmark'
import { CREATE_BOOKMARK } from '@client/collections/Bookmark/schemas/createBookmark'
import { GET_BOOKMARK_LIST } from '@client/collections/Bookmark/schemas/getBookmarkList'
import { REMOVE_BOOKMARK } from '@client/collections/Bookmark/schemas/removeBookmark'
import { REMOVE_BOOKMARK_BY_CHAPTER_ID } from '@client/collections/Bookmark/schemas/removeBookmarkByChapterId'
import { BookmarkListResponse } from '@models/bookmark/BookmarkListResponse'
import { gqlApiInstance } from '@client/init'

export function useBookmarkAction() {
  async function getBookmarkList(
    searchParam: SearchBookListParamType
  ): Promise<BookmarkListResponse> {
    const { getBookmarksByUser } = await gqlApiInstance.request(
      GET_BOOKMARK_LIST,
      {
        limitPerPage: searchParam.perpage,
        page: searchParam.page,
        bookType: searchParam.bookType.length ? searchParam.bookType : null,
        categoryIds: searchParam.categoryId
          ? [Number(searchParam.categoryId)]
          : null,
        searchText: searchParam.text,
        sort: searchParam.sort || null,
      }
    )

    return plainToInstance(BookmarkListResponse, getBookmarksByUser)
  }

  async function isBookmarked(bookChapterId: number): Promise<boolean> {
    const res = await gqlApiInstance.request(CHECK_BOOKMARK, {
      bookChapterId,
    })

    return res.isBookmarked
  }

  async function createBookmark(chapterId: number) {
    await gqlApiInstance.request(CREATE_BOOKMARK, {
      createBookmarkInput: {
        bookChapterId: chapterId,
      },
    })
  }

  async function removeBookmark(id: number) {
    await gqlApiInstance.request(REMOVE_BOOKMARK, {
      id,
    })
  }

  async function removeBookmarkByChapterId(bookChapterId: number) {
    await gqlApiInstance.request(REMOVE_BOOKMARK_BY_CHAPTER_ID, {
      bookChapterId,
    })
  }

  return {
    getBookmarkList,
    isBookmarked,
    createBookmark,
    removeBookmark,
    removeBookmarkByChapterId,
  }
}
